/** Login role options (values sent to OTP / auth APIs). */
export const AUTH_LOGIN_ROLES = [
  { title: 'ARA Admin', value: 10 },
  { title: 'ARA User', value: 20 },
  { title: 'Billing Company', value: 40 },
  { title: 'Treatment Providers', value: 30 },
] as const
